import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomepageDashbaordService {
  private readonly getUserChartsUrl =environment.main_url + environment.userChartsUrl
  private readonly getChartsDataByIdUrl =environment.main_url + environment.chartDataByIdUrl

  constructor(private readonly http: HttpClient) { }

  getUserChartsList(){
      return this.http.get<any>(this.getUserChartsUrl)
  }

  getChartsDataByChartId(chartId:any){
    let payload:any={"filters":[]}
    return this.http.post<any>(this.getChartsDataByIdUrl+"/"+chartId,payload)
  }
}
